import FieldTypesEnum from '../Enums/FieldTypesEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import stringHelper from '../Helpers/stringHelper';

export default class ClientFeeItem {
  constructor(item) {
    if (item === undefined) {
      this.PricingId = '';
      this.PricingDetailName = '';
      this.CountryName = '';
      this.OfficeName = '';
      this.Fee = '';
      this.OpportunityCurrencySymbol = '';
      this.FeeWithSymbol = ''; // Client Fee
      this.CurrencyName = '';
      this.FieldworkFeeBase = '';
      this.CurrencySymbol = '';
      this.NumEvalsTotal = '';
      this.ModifiedOn = '';
      this.HasUserComments = '';
      this.ModifiedOnOnFormatted = '';
      this.OpportunityDisplayName = '';
      this.Status = '';
      this.AssignedToName = '';
      this.PricingDetailVersion = '';
      this.ApprovedByName = '';
      this.ApprovedOn = '';
      return;
    }
    this.PricingId = item.pricingId;
    this.PricingDetailName = item.pricingDetailName;
    this.CountryName = item.countryName;
    this.OfficeName = item.officeName;
    this.Fee = item.fee;
    this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
    this.FeeWithSymbol = stringHelper.getValueWithSymbol('', item.opportunityCurrencySymbol, item.fee);
    this.CurrencyName = item.currencyName;
    this.FieldworkFeeBase = item.fieldworkFeeBase;
    this.CurrencySymbol = item.currencySymbol;
    this.FieldworkFeeBaseWithSymbol = stringHelper.getValueWithSymbol('', item.currencySymbol, item.fieldworkFeeBase);
    this.NumEvalsTotal = item.numEvalsTotal;
    this.ModifiedOn = item.modifiedOn;
    this.HasUserComments = item.hasUserComments;
    this.ModifiedOnOnFormatted = dateTimeHelper.toYYYYsMMsDD(item.modifiedOn, '-');
    this.OpportunityDisplayName = item.opportunityDisplayName;
    this.Status = item.status;
    this.AssignedToName = item.assignedToName;
    this.PricingDetailVersion = item.pricingDetailVersion;
    this.PricingDetailVersionFormatted = `${item.pricingDetailVersion}: ${item.pricingDetailName}`;
    this.ApprovedByName = item.approvedByName;
    this.ApprovedOn = item.approvedOn;
  }

  static NameOfTheIdField() {
    return 'PricingId';
  }
  static nameOfTheItemDetailList() {
    return 'Client Fee';
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'PricingDetailName', label: 'Service', className: 'text-left' },
        { name: 'CountryName', label: 'Country', className: 'text-left' },
        { name: 'OpportunityDisplayName', label: 'Opportunity', className: 'text-left' },
        { name: 'OfficeName', label: 'Fieldwork Office', className: 'text-left' },
        { name: 'NumEvalsTotal', label: 'No. Evals Per Cycle', className: 'text-left' },
        { name: 'CurrencyName', label: 'Currency', className: 'text-left' },
        { name: 'Status', label: 'Status', className: 'text-left' },
        { name: 'AssignedToName', label: 'Assigned To', className: 'text-left' },
        { name: 'PricingDetailVersionFormatted', label: 'Version', className: 'text-left' },
        { name: 'ApprovedByName', label: 'Approved By', className: 'text-left' },
        { name: 'ApprovedOn', label: 'Approved On', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Pricing ID',
        orderById: 'PricingId',
        data: 'PricingId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 50,
      },
      {
        label: 'Pricing Version',
        orderById: 'PricingDetailName',
        data: 'PricingDetailName',
        minWidth: 50,
      },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName', minWidth: 50 },
      { label: 'FW Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 50 },
      {
        label: 'Client Fee',
        orderById: 'FeeWithSymbol',
        data: 'FeeWithSymbol',
        minWidth: 20,
      },
      {
        label: 'FW Fee',
        orderById: 'FieldworkFeeBaseWithSymbol',
        data: 'FieldworkFeeBaseWithSymbol',
        minWidth: 20,
      },
      {
        label: 'Est. Evals',
        orderById: 'NumEvalsTotal',
        data: 'NumEvalsTotal',
        minWidth: 20,
      },
      {
        label: 'Modified On',
        orderById: 'ModifiedOnOnFormatted',
        data: 'ModifiedOnOnFormatted',
        minWidth: 20,
      },
      {
        label: 'Comments?',
        orderById: 'HasUserComments',
        data: 'HasUserComments',
        minWidth: 20,
      },
    ];
  }

  static DateFields = [];

  static MoneyFields = [];

  static MoneyFieldsSecondary = [];

  static BoolFields = [];

  static Currency() {
    return '';
  }

  static CurrencySecondary() {
    return '';
  }
}
